import React from "react";
import "../styles/loading.css";

import podIcon from "../assets/icons/podicon.png";

const Loading = ({ visible = true }) => {
    return (
        <div className={`loading-screen ${visible ? "show" : "hide"}`}>
            <div className="pod-wrapper">

                {/* POD ANIMADO */}
                <img src={podIcon} alt="pod" className="pod-3d" />

                {/* VAPOR CAMADA 1 */}
                <div className="vapor v1"></div>
                {/* CAMADA 2 */}
                <div className="vapor v2"></div>
                {/* CAMADA 3 */}
                <div className="vapor v3"></div>
                <div className="vapor v4"></div>
                <div className="vapor v5"></div>

            </div>
        </div>
    );
};

export default Loading;